import { register } from '@shopify/theme-sections';
import Swiper from 'swiper';

const selectors = {
  target: '.video-slider--',
};

register('video-slider-section', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `${selectors.target}${id}`;
    const targetSelector = document.querySelector(target);

    if (!targetSelector) {
      return;
    }

    const swiper = new Swiper(target, {
      slidesPerView: 1,
      loop: true,
      freeMode: false,
      spaceBetween: 0,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
    });
  },

  onBlockSelect: (blockId) => {
    const id = blockId.detail.sectionId;
    const currentSlide = parseInt(blockId.target.dataset.swiperSlideIndex) + 1;
    const target = `${selectors.target}${id}`;
    console.log(document.querySelector(target))
    const swiper = document.querySelector(target).swiper;
    console.log(swiper)
    swiper.slideTo(currentSlide, 1000, false);

    console.log(`🤠 Slide to block ${currentSlide}`)
  },
});
